"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledPx2rem = _interopRequireDefault(require("../../utils/styled-px2rem"));
var _Tab = _interopRequireDefault(require("../Tab"));
var _excluded = ["component"];
var _templateObject, _templateObject2;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Tabs = /*#__PURE__*/function (_React$PureComponent) {
  function Tabs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Tabs);
    _this = _callSuper(this, Tabs, [props]);
    _this.state = {
      value: props.value
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Tabs, _React$PureComponent);
  return (0, _createClass2["default"])(Tabs, [{
    key: "handleClick",
    value: function handleClick(event) {
      var value = this.state.value;
      var tabElement = event.target.closest('li');
      var nextValue = tabElement.getAttribute('value') !== '0' ? tabElement.getAttribute('value') : tabElement.getAttribute('data-value');
      if (!nextValue || nextValue === value) {
        return;
      }
      var onChange = this.props.onChange;
      this.setState({
        value: nextValue
      }, function () {
        return onChange(nextValue);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        isFunctional = _this$props.functional,
        vertical = _this$props.vertical;
      var value = this.state.value;
      if (isFunctional) {
        return /*#__PURE__*/_react["default"].createElement("ul", {
          className: className
        }, _react["default"].Children.map(children, function (child) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            functional: true,
            onClick: _this2.handleClick
          });
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(StyledTabs, {
        className: className,
        vertical: vertical
      }, _react["default"].Children.map(children, function (child) {
        return /*#__PURE__*/_react["default"].createElement(StyledTab, {
          className: child.props.className,
          component: child,
          onClick: _this2.handleClick,
          selected: child.props.value === value,
          vertical: vertical
        });
      }));
    }
  }]);
}(_react["default"].PureComponent);
Tabs.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].oneOf([_Tab["default"]])
  }).isRequired).isRequired,
  className: _propTypes["default"].string,
  functional: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string,
  vertical: _propTypes["default"].bool
};
Tabs.defaultProps = {
  className: '',
  functional: false,
  onChange: Function.prototype,
  value: null,
  vertical: false
};
var StyledTabs = _styledPx2rem["default"].ul(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n\n  ", "\n"])), function (props) {
  return !props.vertical && "\n    height: 100px;\n    padding-bottom: 12px;\n  ";
}, function (props) {
  return props.vertical && "\n    padding-right: 12px;\n    width: 300px;\n  ";
});
var StyledTab = (0, _styledPx2rem["default"])(function (_ref) {
  var component = _ref.component,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].cloneElement(component, props);
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n\n  ", "\n\n  ", "\n  \n  ", "\n"])), function (props) {
  return !props.vertical && "\n    float: left;\n    height: 100%;\n    margin-bottom: 10px;\n    \n    & + & {\n      margin-left: 5px;\n    }\n  ";
}, function (props) {
  return props.vertical && "\n    margin-right: 10px;\n    width: 100%;\n  \n    & + & {\n      margin-top: 5px;\n    }\n  ";
}, function (props) {
  return !props.vertical && props.selected && "\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-bottom: 0;\n    padding-bottom: 10px;\n  ";
}, function (props) {
  return props.vertical && props.selected && "\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: 0;\n    padding-right: 10px;\n  ";
});
var _default = exports["default"] = Tabs;